import React, { ComponentPropsWithoutRef, useRef, useState } from 'react'
import { SheetContainer, HeaderWrapper, ListBtnText, StickyHeaderWrapper, SecondaryView, SecondaryViewContent } from './style'
import { FeatureModalNoData } from '../commons'
import { Text as StormText } from '@amzn/storm-ui'
import { FeatureModalContent } from './components/FeatureModalContent'
import { FeatureModalList } from './components/FeatureModalList'
import { useEmitInitialRender } from '../../../utils/hooks'
import { useFeatureContext } from '../../../contexts/FeatureContext'
import { taktId } from '../../../utils/takt'
import { WidgetTypes } from '../../../common/constants'

export const MobileFeatureModal: React.VFC = () => {
  const { featureKeys, featureOpen, featureId, featureLabels, featureCloseEvent, setFeatureIdEvent } = useFeatureContext()
  useEmitInitialRender(WidgetTypes.FeatureModalMobile)
  const buttonRef = useRef()

  const [headerHeight, setHeaderHeight] = useState<string>()
  const setHeaderRef = (headerNode) => {
    if (headerNode) setHeaderHeight(window.getComputedStyle(headerNode).height)
  }
  const setContentRefStyles = (contentNode) => {
    if (contentNode && headerHeight) contentNode.style.paddingTop = headerHeight
  }
  const setListContentRefStyles = (contentNode) => {
    if (contentNode && headerHeight) contentNode.style.paddingTop = headerHeight
  }

  return (
    <SecondaryView
      data-takt-id={taktId(WidgetTypes.WhatsNewCenter, 'AACChromePortal', true)}
      isOpen={featureOpen}
      onClose={featureCloseEvent}
      secondaryViewElementId="AACChromePortal"
      toggleEl={buttonRef}
      closeButtonLabel={featureLabels?.fitBack}
      closeButtonProps={{ 'data-takt-id': taktId(WidgetTypes.WhatsNewCenterItem, 'close-button', true) } as unknown as ComponentPropsWithoutRef<'button'>}
      padding="none"
    >
      <SecondaryViewContent>
        <StickyHeaderWrapper ref={setHeaderRef}>
          <HeaderWrapper>
            <StormText fontSize="medium">{featureLabels?.whatsNew}</StormText>
            {featureId && (
              <ListBtnText size="small" onClick={() => setFeatureIdEvent('')} data-takt-id={taktId(WidgetTypes.WhatsNewCenterItem, 'back-list-button', true)}>
                {featureLabels?.fitList}
              </ListBtnText>
            )}
          </HeaderWrapper>
        </StickyHeaderWrapper>
        {featureId ? (
          <SheetContainer ref={setContentRefStyles}>
            <FeatureModalContent />
          </SheetContainer>
        ) : (
          <SheetContainer ref={setListContentRefStyles}>{featureKeys && featureKeys.length > 0 ? <FeatureModalList /> : <FeatureModalNoData />}</SheetContainer>
        )}
      </SecondaryViewContent>
    </SecondaryView>
  )
}
